import { render, staticRenderFns } from "./PatientChangeRequestDialog.vue?vue&type=template&id=3081085d&scoped=true"
import script from "./PatientChangeRequestDialog.vue?vue&type=script&lang=js"
export * from "./PatientChangeRequestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3081085d",
  null
  
)

export default component.exports